import { IconBox, IconChevronCompactUp, IconChevronDown, IconChevronsUp, IconShoppingBag, IconSocial, IconSpeakerphone } from "@tabler/icons-react";

export const AppConstants = {
    inputVariant: 'default',
    defaultPaginationSize: 100,
    ICON_STROKE_WIDTH: 1,
    ICON_SIZE: 18,
    CACHE_DELAY: 600000,
    CACHE_DELAY_LONG: 3600000,
    FILTER_MAX_AGE_IN_DAYS: 7,
    APP_VERSION: "0.2.41"
};

export const SampleActions = {
    BUILD_OUTFIT: 'buildoutfit',
};
export const SessionActions = {
    BUILD_OUTFIT: 'buildoutfit',
    CREATE_SESSION_FROM_SAMPLES: 'createSessionFromSamples',
    ASSIGN_SAMPLES_TO_SESSION: 'assignSamplesToSession',
    ASSIGN_STYLEGUIDE: 'assignStyleGuide',
    REMOVE_STYLEGUIDE: 'removeStyleGuide',
    ASSIGN_SAMPLE: 'sessionAssignSample',
    ASSIGN_TALENT_TO_SAMPLES: 'assignTalentToSamples',
    REMOVE_SAMPLE: 'sessionRemoveSample',
    ASSIGN_CAPTURES_TO_SAMPLES: 'sessionAssignCapturesToSamples',
    DOWNLOAD_PDF_STUB: 'sessionDownloadPDFStub',
    EXPORT_TO_CSV: 'sessionExportCSV',
    ARCHIVE: 'sessionArchive',
    BATCH_UPDATE_STYLES: 'batchUpdateStyles',
};

export const GuideActions = {
    EDIT_GUIDE_CAT: 'guideCategoryEdit',
    ADD_GUIDE_CAT_SHOT: 'guideCategoryAddShot',
    UPDATE_GUIDE_CAT: 'guideCategoryUpdate',
    REMOVE_GUIDE_CAT: 'guideCategoryRemove',
    ARCHIVE_GUIDE_CAT: 'guideCategoryArchive',
    UNARCHIVE_GUIDE_CAT: 'guideCategoryUnArchive',
    // EDIT_GUIDE:'buildoutfit'
};
export const SeasonActions = {
    // EDIT_GUIDE:'buildoutfit'
};

export const Exceptions = {
    SERIALISATION: 'com.amazon.coral.service#SerializationException',
};

export const TaskActions = {
    EDIT_TASK: 'editTask',
    DELETE_TASK: 'deleteTask',
    ADD_TASK: 'addTask',
};

export const TalentActions = {
    EDIT_TALENT: 'editTalent',
    DELETE_TALENT: 'deleteTalent',
    ADD_TALENT: 'addTalent',
    BATCH_EDIT_TALENT: 'batchEditTalent',
};

export const FrameActions = {
    ADD_SAMPLE: 'add_sample',
    CLEAR_FRAME: 'clear_frame',
    DELETE_FRAME: 'delete_frame',
    CLOSE: 'close',
    ADD_FRAME: 'add_frame',
    SAMPLE_CLICK: 'sample_click',
    DELETE_SAMPLE: 'delete_sample',
    REPLACE_SAMPLE: 'replace_sample',
};

export const SETTINGS = {
    TOOLBAR_HEIGHT: 60,
    TOOLBAR_WIDTH: 60,
    FILTER_PANEL_MAX_HEIGHT:'calc(100vh - 500px)',
    FILTER_PANEL_MAX_HEIGHT_LG:'calc(100vh - 380px)'
};
export const ItemTypes = {
    FRAME: 'frame',
    BOX: 'box',
    CAPTURE: 'capture',
};

export const ApprovalLayoutTypes = {
    GRID: 'grid',
    SINGLE: 'single',
    COMPARE: 'compare',
    COMMENT: 'comment',
    STACKED: 'stacked',
};

export const ApprovalImageToolbarModes = {
    ZOOM_IN: 'zoomIn',
    ZOOM_OUT: 'zoomOut',
    ZOOM_RESET: 'zoomReset',
    MARKUP: 'markup',
};

export const FlagRating = {
    FLAG_SELECT: '1',
    FLAG_KILL: '2',
};

export const DataFormats = {
    DATE_FORMAT: 'MMMM Do YYYY',
    DATE_FORMAT_SHORT: 'DD/MM/YYYY',
    DATE_FORMAT_REST: 'YYYY-MM-DD',
    TIMEZONE: 'Australia/Melbourne',
    DATE_FORMAT_CREATE_PARSE: 'YYYY-MM-DD-hh-mm-ss',
    TIME_FORMAT: 'hh:mm A',
};

export const SessionTypes = {
    UNKOWN: 'Session_Unknown',
};

export const ViewModes = {
    EDIT: 'viewEdit',
    VIEW: 'viewView',
    ADD: 'viewAdd',
};
export const TreatmentTypes = {
    POST_PRODUCTION: { label: 'Post Production', value: 'Post Production' },
    RETOUCHING: { label: 'Retouching', value: 'Retouching' },
};

export const PaginationValues = [
    { value: 20, label: 'Show 20' },
    { value: 50, label: 'Show 50' },
    { value: 80, label: 'Show 80' },
    { value: 100, label: 'Show 100' },
];

export const APP_ENV = process.env.NODE_ENV === 'development' ? 'development' : 'production';
export const LOG_LEVEL = APP_ENV === 'production' ? 'warn' : 'log';

export const ResponseCodes = {
    ABORT_ERROR: 20,
};
export const SHELL_TAB_BAR_HEIGHT = 65;

export const ObjectKeys = ['S', 'N', 'L'];

export const StatusTypes = {
    PENDING: 'Pending',
    ASSIGNED: 'Assigned',
    IN_APPROVAL: 'In Approval',
    COMPLETE: 'Complete',
    CANCELLED: 'Cancelled',
};

export const StatusTypeArray = [StatusTypes.PENDING, StatusTypes.ASSIGNED, StatusTypes.IN_APPROVAL, StatusTypes.COMPLETE, StatusTypes.CANCELLED];

const colors = {
    Y50: '#70575A',
    B50: '#4C616D',
    G50: '#505050',
    P50: '#3F5654',
    N400A: 'grey',
};

export const status_unassigned = {
    id: '0',
    name: 'Unassigned',
    label: 'Unassigned',
    value: 'unassigned',
    url: '',
    avatarUrl: null,
    colors: {
        soft: colors.Y50,
        hard: colors.N400A,
        primary: 'grey',
    },
};

export const status_backlog = {
    id: '1',
    name: 'Pending',
    label: 'Pending',
    value: 'pending',
    url: '',
    avatarUrl: null,
    colors: {
        soft: colors.Y50,
        hard: colors.N400A,
        primary: 'grey',
    },
};

export const status_selected = {
    id: '2',
    name: 'Assigned',
    label: 'Assigned',
    value: 'assigned',
    url: '',
    avatarUrl: null,
    colors: {
        soft: colors.G50,
        hard: colors.N400A,
        primary: 'violet',
    },
};

export const status_progress = {
    id: '3',
    name: 'In Approval',
    label: 'In Approval',
    value: 'inapproval',
    url: '',
    avatarUrl: null,
    colors: {
        soft: colors.B50,
        hard: colors.N400A,
        primary: 'blue',
    },
};

export const status_complete = {
    id: '4',
    name: 'Complete',
    label: 'Complete',
    value: 'complete',
    url: '',
    avatarUrl: null,
    colors: {
        soft: colors.P50,
        hard: colors.N400A,
        primary: 'teal',
    },
};

export const status_canceled = {
    id: '5',
    name: 'Cancelled',
    label: 'Cancelled',
    value: 'cancelled',
    url: '',
    avatarUrl: null,
    colors: {
        soft: colors.P50,
        hard: colors.N400A,
        primary: 'red',
    },
};

export const statuss = [status_backlog, status_selected, status_progress, status_complete, status_canceled];

export const PHOTOSHOP_FILE_TYPES = '.psd,.jpg,.png';

export const colorThemes = ['light', 'dark', 'blue', 'cyan', 'gray', 'indigo', 'lime', 'orange', 'pink', 'purple', 'red', 'teal', 'yellow'];

export const userRoles = [
    { label: 'Sample Co-ordinator', value: 'Sample Co-ordinator' },
    { label: 'Art Director', value: 'Art Director' },
    { label: 'Producer', value: 'Producer' },
    { label: 'Photographer', value: 'Photographer' },
    { label: 'Retoucher', value: 'Retoucher' },
    { label: 'Stylist', value: 'Stylist' },
];


export const shotChannelItems = {
    PACKAGING: { label: 'Packaging', value: 'Packaging', icon: <IconBox size={16} stroke={AppConstants.ICON_STROKE_WIDTH} />, color: 'grape' },
    E_COMMERCE: { label: 'e-commerce', value: 'e-commerce', icon: <IconShoppingBag size={16} stroke={AppConstants.ICON_STROKE_WIDTH} />, color: 'blue' },
    SOCIAL: { label: 'Social', value: 'Social', icon: <IconSocial size={16} stroke={AppConstants.ICON_STROKE_WIDTH} />, color: 'orange' },
    CAMPAIGN: { label: 'Campaign', value: 'Campaign', icon: <IconSpeakerphone size={16} stroke={AppConstants.ICON_STROKE_WIDTH} />, color: 'violet' },
}
export const shotChannels = Object.values(shotChannelItems);

export const shotTags = [
    { label: 'Hero', value: 'Hero' },
    { label: 'Hover', value: 'Hover' },
];

export const ScanStatusItems = [
    { label: 'Pending', value: 'PENDING' },
    { label: 'Succeeded', value: 'SUCCEEDED' },
    { label: 'Failure', value: 'FAILURE' },
    { label: 'Abandoned', value: 'ABANDONED' },
    { label: 'Created', value: 'CREATED' },
    { label: 'Parsed', value: 'PARSED' },
    { label: 'Master record not found', value: 'MASTER_NOT_FOUND' },
    { label: 'A2 Record not found', value: 'LOCAL_NOT_FOUND' },
];

export const ScanStatuses = {
    PENDING: { label: 'Pending', value: 'PENDING' },
    SUCCEEDED: { label: 'Succeeded', value: 'SUCCEEDED' },
    FAILURE: { label: 'Failure', value: 'FAILURE' },
    ABANDONED: { label: 'Abandoned', value: 'ABANDONED' },
    CREATED: { label: 'Created', value: 'CREATED' },
    PARSED: { label: 'Parsed', value: 'PARSED' },
    MASTER_NOT_FOUND: { label: 'Master record not found', value: 'MASTER_NOT_FOUND' },
    LOCAL_NOT_FOUND: { label: 'A2 Record not found', value: 'LOCAL_NOT_FOUND' },
};

export const Genders = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: '-', value: ' ' },
];

export const dataViewSettings = {
    defaultPaginationSize: 100,
};

export const SampleGrades = [
    { label: 'Satisfactory', value: 'Satisfactory' },
    { label: 'Damaged', value: 'Damaged' },
];

export const CompanyFormats = {
    KMA: {
        ASSET_DISTRIBUTION_NAME: ({ style, shot }) => `${shot.capture?.stylePart}-${shot.distIndex}.jpg`,
        LABELS:{
          style:'Keycode',
          name:'Item Description',
          otbDate:'In-Store Date'
        }
    },
    TAR: {
        ASSET_DISTRIBUTION_NAME: ({ style, shot }) =>
            `${style.deptCode === null || style.deptCode === undefined ? 'Undefined' : style.deptCode === '' ? 'Undefined' : style.deptCode}_${shot.capture?.stylePart}_${shot.distIndex}.jpg`,
        LABELS:{
            style:'Style',
            name:'Name',
            otbDate:'OTB Date'
          }
    },
    DEFAULT: {
        ASSET_DISTRIBUTION_NAME: ({ style, shot }) => `${style.deptCode === null || style.deptCode === undefined ? 'Undefined' : 
 style.deptCode === '' ? 'Empty' : style.deptCode}_${shot.capture?.stylePart}_${shot.distIndex}.jpg`,
        LABELS:{
            style:'Style',
            name:'Name',
            otbDate:'OTB Date'
        }
    },
};

export const CompanyFormatFields = {
    ASSET_DISTRIBUTION_NAME: 'ASSET_DISTRIBUTION_NAME',
};

export const CompanyTableColumns = {
    KMA: {
        seasonMasters: [               
            {
                accessor: 'KEYCODE',
                Header: 'Keycode',
                width: 150,
            },
            {
                accessor: 'STYLE NO',
                Header: 'Style No',
                width: 120,
            },
            {
                accessor: 'SAMPLEIDENTIFIERS',
                Header: 'Sample Identifiers',
                width: 200,
            },
            {
                accessor: 'ITEM/STYLE DESCRIPTION',
                Header: 'Item/Style Description',
                width: 300,
            },
            {
                accessor: 'BARCODE',
                Header: 'Barcode',
                width: 150,
            },
            {
                accessor: 'SIZE',
                Header: 'Size',
                width: 100,
            },
            {
                accessor: 'VENDOR',
                Header: 'Vendor',
                width: 150,
            },
            {
                accessor: 'DEPT',
                Header: 'Dept',
                width: 100,
            },
            {
                accessor: 'DEPT NAME',
                Header: 'Dept Name',
                width: 200,
            },
            {
                accessor: 'INSTORE',
                Header: 'Instore',
                width: 100,
            }    
        ],
        seasonStyles: [
            {
                Header: 'Keycode',
                accessor: 'instructions["Web Photography Code"]',
                sortType: 'alphanumeric',
                width: 150,
            },
            // {
            //     Header: 'Style',
            //     accessor: 'seasonSort',
            //     sortType: 'alphanumeric',
            //     width: 100,
            // },
            {
                Header: 'Style No',
                accessor: 'instructions["STYLE NO"]',
                sortType: 'alphanumeric',
                width: 150,
                show: false,
            },
            {
                Header: 'Sample Identifier',
                accessor: 'instructions["SAMPLEINDENTIFIER"]',
                sortType: 'alphanumeric',
                width: 200,
                show: false,
            },
            {
                Header: 'Multi Shot',
                accessor: 'multiShotFlag',
                sortType: 'alphanumeric',
                width: 100,
                show: true,
            },
            {
                Header: 'Status',
                accessor: 'styleCount',
                sortType: 'alphanumeric',
            },
            {
                Header: 'Priority',
                accessor: 'priority',
                sortType: 'alphanumeric',
                width: 120,
                show: true,
            },
            {
                Header: 'Session',
                accessor: 'studioSessionCodes',
                sortType: 'alphanumeric',
            },
            {
                Header: 'Item Description',
                accessor: 'instructions["Name"]',
                sortType: 'alphanumeric',
                show: true,
            },
            {
                Header: 'Notes',
                accessor: 'instructions["Web Photography Notes"]',
                sortType: 'alphanumeric',
                show: true,
            },
            {
                Header: 'Size',
                accessor: 'instructions["Web Photography Sample Size"]',
                sortType: 'alphanumeric',
                width: 100,
                show: true,
            },
            {
                Header: CompanyFormats.KMA.LABELS.otbDate,
                accessor: 'instructions["Web Stock OTB Date"]',
                sortType: 'alphanumeric',
                width: 130,
                show: true,
            },
            {
                Header: 'Sample Notes',
                accessor: 'sampleNotes',
                sortType: 'alphanumeric',
                show: true,
            },
            {
                Header: 'Sample Grade',
                accessor: 'sampleGrade',
                sortType: 'alphanumeric',
                show: true,
            },
            // {
            //     Header: 'Style',
            //     accessor: 'instructions["Web Photography Style"]',
            //     sortType: 'alphanumeric',
            //     width: 80,
            //     show: true,
            // },
            {
                Header: 'Department',
                accessor: 'instructions["departmentStr"]',
                sortType: 'alphanumeric',
                show: true,
            },
            // {
            //     Header: 'Scan',
            //     accessor: 'scan.scanned',
            //     sortType: 'dateSorter',
            //     width: 120,
            //     show: true,
            // },
            {
                accessor: 'created',
                Header: 'Created',
                sortType: 'dateSorter',
                width: 100,
                show: true,
            },       
            {
                accessor: 'origin',
                Header: 'Origin',
                sortType: 'alphanumeric',
                width: 100,
                show: true,
            }, 

            // {
            //     Header: 'Keycode',
            //     accessor: 'instructions["KEYCODE"]',
            //     sortType: 'alphanumeric',
            //     width: 200,
            //     show: false,
            // },
            
            {
                Header: 'Item Description',
                accessor: 'instructions["ITEM DESCRIPTION"]',
                sortType: 'alphanumeric',
                width: 200,
                show: false,
            },
            {
                Header: 'Barcode',
                accessor: 'instructions["BARCODE"]',
                sortType: 'alphanumeric',
                width: 200,
                show: false,
            },
            // {
            //     Header: 'Size',
            //     accessor: 'instructions["SIZE"]',
            //     sortType: 'alphanumeric',
            //     width: 200,
            //     show: false,
            // },
            {
                Header: 'Dept',
                accessor: 'instructions["DEPT"]',
                sortType: 'alphanumeric',
                width: 200,
                show: false,
            },
            {
                Header: 'Dept Name',
                accessor: 'instructions["DEPT NAME"]',
                sortType: 'alphanumeric',
                width: 200,
                show: false,
            },
            // {
            //     Header: 'In-Store OTB',
            //     accessor: 'instructions["IN STORE"]',
            //     sortType: 'alphanumeric',
            //     width: 200,
            //     show: false,
            // },
            // {
            //     Header: 'In-Store',
            //     accessor: 'IN-STORE',
            //     sortType: 'alphanumeric',
            //     width: 200,
            //     show:false,
            // },
        ],
        globalSearchStyleMasters: [
            // { accessor: 'targetId', Header: 'Target ID', width: 120 },
            { accessor: 'version', Header: 'Version', width: 150 },
            { accessor: 'productStatus', Header: 'Product Status', width: 120, type: 'status' },
            { accessor: 'styleNumber', Header: 'Style Number', width: 130 },
            // { accessor: 'targetKeycode', Header: 'Target Keycode', width: 120 },
            { accessor: 'colour', Header: 'Colour', width: 120 },
            { accessor: 'brand', Header: 'Brand', width: 100 },
            { accessor: 'kmartKeycode', Header: 'Kmart Keycode', width: 120 },
            { accessor: 'variation', Header: 'Variation', width: 100 },
            { accessor: 'dept', Header: 'Dept', width: 200 },
            { accessor: 'modified', Header: 'Modified', width: 180, type: 'date' },
            { accessor: 'variationSize', Header: 'Variation Size', width: 120 },
            { accessor: 'otb', Header: CompanyFormats.KMA.LABELS.otbDate, width: 120 },
            { accessor: 'productName', Header: 'Product Name', width: 250 },
            { accessor: 'apn', Header: 'APN', width: 130 },
            // { accessor: 'targetSort', Header: 'Target Sort', width: 150 },
        ],
    },
    TAR: {
        seasonMasters: [
            {
                accessor: 'TARGET KEYCODE',
                Header: 'Keycode',
                id: 'keycode',
                cell: (info) => info.getValue(),
            },
            {
                accessor: 'APN',
                Header: 'APN',
                width: 200,
                id: 'apn',
                cell: (info) => info.getValue(),
            },
            // {
            //     accessor: 'keycode',
            //     Header: 'Keycode',
            //     width: 150,
            // },
            {
                accessor: 'STYLE NUMBER',
                Header: 'Style Number',
                id: 'styleNumber',
                cell: (info) => info.getValue(),
            },
            {
                accessor: 'PRODUCT NAME',
                Header: 'Product Name',
                width: 300,
                id: 'productName',
                cell: (info) => info.getValue(),
            },
            {
                accessor: 'DEPT NAME',
                Header: 'Department',
                width: 200,
                id: 'department',
                cell: (info) => info.getValue(),
            },
            {
                accessor: 'COLOUR',
                Header: 'Colour',
                width: 120,
                id: 'colour',
                cell: (info) => info.getValue(),
            },
            {
                accessor: 'VARIATION',
                Header: 'Variation',
                width: 130,
                id: 'variation',
                cell: (info) => info.getValue(),
            },
            {
                accessor: 'VARIATION SIZE',
                Header: 'Variation Size',
                width: 150,
                id: 'variationSize',
                cell: (info) => info.getValue(),
            },
            {
                accessor: 'PRODUCT STATUS',
                Header: 'Product Status',
                id: 'productStatus',
                cell: (info) => info.getValue(),
            },
            {
                accessor: 'OTB',
                Header: CompanyFormats.TAR.LABELS.otbDate,
                width: 170,
                id: 'otb',
                cell: (info) => info.getValue(),
            },
        ],
        seasonStyles: [
            {
                Header: 'Photo Code',
                accessor: 'instructions["Web Photography Code"]',
                sortType: 'childrenPriority',
                width: 220,
            },
            {
                Header: 'Style',
                accessor: 'seasonSort',
                sortType: 'alphanumeric',
                width: 100,
            },
            {
                Header: 'Multi Shot',
                accessor: 'multiShotFlag',
                sortType: 'alphanumeric',
                width: 100,
                show: true,
            },
            {
                Header: 'Outfitting',
                accessor: 'outfittingFlag',
                sortType: 'alphanumeric',
                width: 100,
                show: true,
            },
            {
                Header: 'Channels',
                accessor: 'channels',
                sortType: 'alphanumeric',
                width: 100,
                show: false,
            },
            {
                Header: 'Status',
                accessor: 'styleCount',
                sortType: 'alphanumeric',
            },{
                Header: 'Priority',
                accessor: 'priority',
                sortType: 'alphanumeric',
                width: 120,
                show: true,
            },
            {
                Header: 'Session',
                accessor: 'studioSessionCodes',
                sortType: 'alphanumeric',
            },            
            {
                Header: 'Name',
                accessor: 'instructions["Name"]',
                sortType: 'alphanumeric',
                show: true,
            },
            {
                Header: 'Notes',
                accessor: 'instructions["Web Photography Notes"]',
                sortType: 'alphanumeric',
                show: true,
            },
            {
                Header: 'Size',
                accessor: 'instructions["Web Photography Sample Size"]',
                sortType: 'alphanumeric',
                width: 100,
                show: true,
            },
            {
                Header: CompanyFormats.TAR.LABELS.otbDate,
                accessor: 'instructions["Web Stock OTB Date"]',
                sortType: 'alphanumeric',
                width: 120,
                show: true,
            },
            // {
            //     Header: 'ODBMS APN (GTIN)',
            //     accessor: 'instructions["ODBMS APN (GTIN)"]',
            // },
            {
                Header: 'Sample Notes',
                accessor: 'sampleNotes',
                sortType: 'alphanumeric',
                show: true,
            },
            {
                Header: 'Sample Grade',
                accessor: 'sampleGrade',
                sortType: 'alphanumeric',
                show: true,
            },
            {
                Header: 'Style',
                accessor: 'instructions["Web Photography Style"]',
                sortType: 'alphanumeric',
                width: 80,
                show: true,
            },
            // {
            //     Header: 'Dept',
            //     accessor: 'instructions["Dept"]',
            // },
            {
                Header: 'Department',
                accessor: 'instructions["departmentStr"]',
                sortType: 'alphanumeric',
                width: 200,
                show: true,
            },
            // {
            //     Header: 'Scan',
            //     accessor: 'scan.scanned',
            //     sortType: 'dateSorter',
            //     width: 120,
            //     show: true,
            // },
            {
                accessor: 'created',
                Header: 'Created',
                sortType: 'dateSorter',
                width: 100,
                show: true,
            },       
            {
                accessor: 'origin',
                Header: 'Origin',
                sortType: 'alphanumeric',
                width: 100,
                show: true,
            }, 
            {
                Header: 'Page',
                accessor: 'pageNumber',
                sortType: 'alphanumeric',
                show: true,
            }
        ],
        globalSearchStyleMasters: [
            // { accessor: 'targetId', Header: 'Target ID', width: 120 },
            { accessor: 'version', Header: 'Version', width: 150 },
            { accessor: 'productStatus', Header: 'Product Status', width: 120, type: 'status' },
            { accessor: 'styleNumber', Header: 'Style Number', width: 130 },
            { accessor: 'targetKeycode', Header: 'Target Keycode', width: 120 },
            { accessor: 'colour', Header: 'Colour', width: 120 },
            { accessor: 'brand', Header: 'Brand', width: 100 },
            // { accessor: 'kmartKeycode', Header: 'Kmart Keycode', width: 120 },
            { accessor: 'variation', Header: 'Variation', width: 100 },
            { accessor: 'dept', Header: 'Dept', width: 200 },
            { accessor: 'modified', Header: 'Modified', width: 180, type: 'date' },
            { accessor: 'variationSize', Header: 'Variation Size', width: 120 },
            { accessor: 'otb', Header: CompanyFormats.TAR.LABELS.otbDate, width: 120 },
            { accessor: 'productName', Header: 'Product Name', width: 250 },
            { accessor: 'apn', Header: 'APN', width: 130 },
            // { accessor: 'targetSort', Header: 'Target Sort', width: 150 },
        ],
    },
};

export const CaptureColorSelectionValues = [
    // { label: 'None', value: '', color: 'gray' },
    // { label: 'Red', value: 'red', color: 'red' },
    // { label: 'Green', value: 'green', color: 'green' },
    // { label: 'Blue', value: 'blue', color: 'blue' },
    // { label: 'Yellow', value: 'yellow', color: 'yellow' },
    // { label: 'Purple', value: 'purple', color: 'violet' },
    // { label: 'Orange', value: 'orange', color: 'orange' },
    // { label: 'Pink', value: 'pink', color: 'pink' },
    { label: 'None', value: '0', color: 'gray' },
    { label: 'Red', value: '1', color: 'red' },
    { label: 'Orange', value: '2', color: 'orange' },
    { label: 'Yellow', value: '3', color: 'yellow' },
    { label: 'Green', value: '4', color: 'green' },
    { label: 'Blue', value: '5', color: 'blue' },
    { label: 'Pink', value: '6', color: 'pink' },
    { label: 'Purple', value: '7', color: 'violet' }
    
];

export const StudioClientProdStatusTypes = {
    COMPLETE: {value: "COMPLETE", label: "Complete"},
    REVIEW: {value: "REVIEW", label: "Sent for Capture Review"},
    DRAFT: {value: "DRAFT", label: "Draft"},
  };


  export const StudioClientPostStatusTypes = {
    COMPLETE: {value: "COMPLETE", label: "Complete"},
    REVIEW: {value: "REVIEW", label: "Sent for Retouching Review"},
    DRAFT: {value: "DRAFT", label: "Draft"},
  };

  export const PriorityTypes = [
    {value: "HIGH", label: "High", icon: <IconChevronsUp />, color: "red" },
    {value: "MEDIUM", label: "Medium", icon: <IconChevronCompactUp />, color: "yellow" },
    {value: "LOW", label: "Low", icon: <IconChevronDown />, color: "blue" },
  ];

  export const ERROR_TYPES = {
    // Network Errors
    NETWORK_ERROR: "NETWORK_ERROR",
    CONNECTION_REFUSED: "CONNECTION_REFUSED",
    TIMEOUT: "REQUEST_TIMEOUT",
  
    // HTTP Status Code Errors
    BAD_REQUEST: "BAD_REQUEST",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    NOT_FOUND: "NOT_FOUND",
    SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  
    // Authentication Errors
    TOKEN_EXPIRED: "TOKEN_EXPIRED",
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  
    // Validation Errors
    VALIDATION_ERROR: "VALIDATION_ERROR",
    UNPROCESSABLE_ENTITY: "UNPROCESSABLE_ENTITY",
  
    // Generic Errors
    UNKNOWN_ERROR: "UNKNOWN_ERROR",
    UNEXPECTED_ERROR: "UNEXPECTED_ERROR",
  };
  export const ERROR_MESSAGES = {
    [ERROR_TYPES.NETWORK_ERROR]: "Network connection failed",
    [ERROR_TYPES.UNAUTHORIZED]: "You are not authorized to access this resource",
    [ERROR_TYPES.NOT_FOUND]: "Requested resource was not found",
    [ERROR_TYPES.SERVER_ERROR]: "Internal server error occurred",
    [ERROR_TYPES.TOKEN_EXPIRED]: "Your session has expired",
  };
  